import { h } from 'preact';
import styles from './PageCard.module.scss';
export function PageCard({ page }) {
    const excerpt = page.summary_html || page.body_html;
    const cleanExcerpt = excerpt
        ? excerpt.replace(/<[^>]*>/g, '').substring(0, 150) + '...'
        : '';
    return (h("a", { href: page.url, class: styles.pageCard },
        page.image && (h("div", { class: styles.pageImage },
            h("img", { src: page.image.src, alt: page.image.alt || page.title }))),
        h("div", { class: styles.pageContent },
            h("span", { class: styles.pageTitle }, page.title),
            cleanExcerpt && h("p", { class: styles.pageExcerpt }, cleanExcerpt),
            h("span", { class: styles.readMore }, "Read More \u2192"))));
}
